if (!customElements.get('cr-better-recipe')) {
  class CrBetterRecipe extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.slideContainer = this.querySelector('.swiper-container');
      if (!this.slideContainer) return;

      this.slideCount = this.querySelectorAll('.swiper-slide').length;
      this.initSlider();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    getLayoutConfig() {
      const width = window.innerWidth;

      if (width >= 1024) {
        return { fullSlides: 3, leftPeek: 0.5, rightPeek: 0.5, gap: 20 };
      }

      if (width >= 768) {
        return { fullSlides: 1, leftPeek: 0.35, rightPeek: 0.35, gap: 20 };
      }

      // Mobile: 1 full card + half of the next card peeking on the right
      return { fullSlides: 1, leftPeek: 0, rightPeek: 0.5, gap: 16 };
    }

    getSlidesVisible(config) {
      return config.fullSlides + config.leftPeek + config.rightPeek;
    }

    getGapCount(config) {
      return Math.ceil(config.fullSlides + config.rightPeek);
    }

    getContainerWidth() {
      const styles = window.getComputedStyle(this);
      const paddingLeft = parseFloat(styles.paddingLeft) || 0;
      const paddingRight = parseFloat(styles.paddingRight) || 0;

      return this.clientWidth - paddingLeft - paddingRight;
    }

    updateSlideLayout() {
      const config = this.getLayoutConfig();
      const gap = config.gap;
      const slidesVisible = this.getSlidesVisible(config);
      const gapCount = this.getGapCount(config);
      const containerWidth = this.getContainerWidth();
      const slideWidth = (containerWidth - gapCount * gap) / slidesVisible;
      const peekOffset = slideWidth * config.leftPeek;
      const peekRight = slideWidth * config.rightPeek;

      this.style.setProperty('--cr-slide-w', `${slideWidth}px`);
      this.style.setProperty('--cr-peek-offset', `${peekOffset}px`);
      this.style.setProperty('--cr-peek-right', `${peekRight}px`);
      this.style.setProperty('--cr-gap', `${gap}px`);

      this.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.style.width = `${slideWidth}px`;
      });

      return slideWidth;
    }

    getSliderSettings() {
      const config = this.getLayoutConfig();
      const gap = config.gap;
      const slidesVisible = this.getSlidesVisible(config);
      const enableLoop = this.slideCount > 1;

      return {
        slidesPerView: 'auto',
        spaceBetween: gap,
        loop: enableLoop,
        loopedSlides: this.slideCount,
        loopAdditionalSlides: Math.max(Math.ceil(slidesVisible), 2),
        grabCursor: true,
        watchOverflow: false,
        speed: 500,
        slideToClickedSlide: false,
        resistanceRatio: 0.65,
      };
    }

    initSlider() {
      this.updateSlideLayout();
      this.slider = new MinimogLibs.Swiper(this.slideContainer, this.getSliderSettings());

      if (this.slider.params.loop) {
        this.slider.slideToLoop(0, 0, false);
      }
    }

    onResize() {
      if (!this.slider) return;

      const activeIndex = this.slider.realIndex;
      this.slider.destroy(true, true);
      this.initSlider();

      if (this.slider.params.loop && activeIndex >= 0) {
        this.slider.slideToLoop(activeIndex, 0, false);
      }
    }
  }

  customElements.define('cr-better-recipe', CrBetterRecipe);
}
